import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  TextInput,
  Platform,
  ActivityIndicator,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { styles } from "../style/FoundryStyle";
import { SCREEN_IDS } from "../components/FullComponent.js";
import { typeConnect } from "../constants/Constants";
import { getFullMo, insertNewWeight } from "../services/ConnectDataBase";
import { getCurrentDateTime } from "../services/Functions";
import { updateListaPesos } from "../redux/reducers";
import DeleteWeightButton from "../components/Pesajes/ComponentDeleteWeightButton";
import { translateText } from "../translations/translationService";
import { INITIAL_WEIGHING_COLORS } from "../style/colors.js";
import AppDialog from "../components/Common/ui/AppDialog";
import AppButton from "../components/Common/ui/AppButton";

export default function InitialWeighing() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const infoData = useSelector((state) => state.infoData);
  const lang = useSelector((state) => state.lang.value);
  const screenName = "WeighingAdminSection";
  const currentScreenId = SCREEN_IDS.ADMINWEIGHT;
  const tipo_tiempo = "WEIGHT";
  const listData = useSelector((state) => state.pesosList.listaPesos);
  const [refSearch, setRefSearch] = useState("");
  const [searchedPO, setSearchedPO] = useState("");
  const usuario = useSelector((state) => state.user.name);
  const equipo = useSelector((state) => state.user.team);
  const [searchResult, setSearchResult] = useState(null);
  const [weights, setWeights] = useState({});
  const [newWeight, setNewWeight] = useState(0);
  const [cantidadInput, setCantidadInput] = useState(0);

  // Confirmación (reemplaza confirm nativo)
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const confirmResolverRef = useRef(null);

  const askConfirm = (message) => {
    return new Promise((resolve) => {
      confirmResolverRef.current = resolve;
      setConfirmMessage(message);
      setConfirmVisible(true);
    });
  };
  const [newCantidad, setNewCantidad] = useState(0);

  const firstLineData = {
    po: "PO",
    mo: "MO",
    cantidad: "Cantidad",
    referencia: "Referencia",
    fechaentrega: "d/f Entrega",
    stamping: "Stamping",
    term: "Cantidad term.",
    peso: "Peso",
    key: "firstLine",
    Peso: "Peso Clasificación",
    Add: "Añadir Peso",
  };

  const getMo = useCallback(async () => {
    setIsLoading(true);
    try {
      const fullMo = await getFullMo(
        screenName,
        typeConnect[0],
        currentScreenId
      );

      const moArray = Object.entries(fullMo).map(([po, mo], index) => ({
        key: po,
        po,
        ...mo,
      }));
      setIsLoading(false);
      dispatch(updateListaPesos(moArray));

      const initialWeights = moArray.reduce((acc, item) => {
        acc[item.key] = "";
        return acc;
      }, {});

      const initialCantidad = moArray.reduce((acc, item) => {
        acc[item.key] = "";
        return acc;
      }, {});
      setWeights(initialWeights);
      setCantidadInput(initialCantidad);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getMo();
  }, []);

  const handleWeightChange = (mo, weight) => {
    if (/^\d+(\.\d*)?$/.test(weight) || weight === "") {
      setNewWeight(weight);
      setWeights((prevWeights) => ({
        ...prevWeights,
        [mo]: weight,
      }));
    }
  };

  const handleWeightDeleted = () => {
    getMo();
  };

  const handleCantidadChange = (mo, cantidad) => {
    if (/^\d+(\.\d*)?$/.test(cantidad) || cantidad === "") {
      setNewCantidad(cantidad);
      setCantidadInput((prevCantidadInput) => ({
        ...prevCantidadInput,
        [mo]: cantidad,
      }));
    }
  };

  const handleKeyPress = (event) => {
    if (event.nativeEvent.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    const trimmedRefSearch = refSearch.trim();
    setSearchedPO(trimmedRefSearch);

    const result = listData.find(
      (item) => item.mo === trimmedRefSearch.replace("'", "-")
    );
    setSearchResult(result);
    setRefSearch("");
  };

  const handleAdd = async (item) => {
    let limiteSuperior = newCantidad * (item.gramos * 1.07);
    let limiteInferior = newCantidad * (item.gramos * 0.97);
    let pendiente = item.cantidad - item.cantidad_terminada;
    if (/^\d+\.\d+$/.test(newWeight)) {
      if (newCantidad <= pendiente) {
        if (Platform.OS === "web") {
          let mensajeConfirmacion = "¿El peso: " + newWeight + " es correto?";
          if (newWeight >= limiteInferior && newWeight <= limiteSuperior) {
            if (newWeight && parseFloat(newWeight) !== 0) {
              const status = await insertNewWeight(
                item.po,
                item.mo,
                usuario,
                equipo,
                1,
                newWeight,
                getCurrentDateTime(),
                "Clasif.",
                tipo_tiempo,
                currentScreenId,
                newCantidad
              );
              if (status) {
                setSearchResult(null);
                await getMo();
                console.log("update weight value.");
              }
            } else {
              console.log("Invalid weight value.");
            }
          } else {
            const test = await askConfirm(mensajeConfirmacion);
            if (test) {
              if (newWeight && parseFloat(newWeight) !== 0) {
                const status = await insertNewWeight(
                  item.po,
                  item.mo,
                  usuario,
                  equipo,
                  1,
                  newWeight,
                  getCurrentDateTime(),
                  "Clasif.",
                  tipo_tiempo,
                  currentScreenId,
                  newCantidad
                );
                if (status) {
                  setSearchResult(null);
                  await getMo();
                  console.log("update weight value.");
                }
              } else {
                console.log("Invalid weight value.");
              }
            }
          }
        } else {
          if (newWeight && parseFloat(newWeight) !== 0) {
            const ok = await askConfirm(
              "¿Estás seguro de que deseas insertar este peso?"
            );
            if (!ok) {
              console.log("Inserción de peso cancelada.");
              return;
            }

            const status = await insertNewWeight(
              item.po,
              item.mo,
              usuario,
              equipo,
              1,
              newWeight,
              getCurrentDateTime(),
              "Term.",
              tipo_tiempo,
              currentScreenId,
              newCantidad
            );
            if (status) {
              setSearchResult(null);
              await getMo();
              console.log("update weight value.");
            }
          } else {
            console.log("Invalid weight value.");
          }

          return;
        }
      }
    } else {
      console.log("El peso no es correcto");
    }
  };

  const renderFirstLine = () => {
    return (
      <View
        style={[
          styles.row,
          styles.FilasStyle,
          { justifyContent: "center", backgroundColor: INITIAL_WEIGHING_COLORS.BACKGROUND_BUTTON },
        ]}>
        <Text style={[styles.tableItemText]}>{firstLineData.po}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.mo}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.cantidad}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.referencia}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.fechaentrega}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.stamping}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.term}</Text>
        <Text style={[styles.tableItemText]}>{firstLineData.peso}</Text>
        <View style={styles.marginTitleAddWeight}>
          <Text style={[styles.tableItemText]}>{"        "}</Text>
        </View>
      </View>
    );
  };

  const renderItem = ({ item }) => {
    if (item.key === "firstLine") {
      return renderFirstLine();
    }

    const calculatedPlaceholder = `aprox: ${
      item.gramos * (item.cantidad - item.cantidad_terminada)
    } gr`;
    const cantidadPlaceholder = `Res: ${Math.round(
      item.cantidad - item.cantidad_terminada
    )}`;
    return (
      <View
        style={[styles.row, styles.FilasStyle, { justifyContent: "center" }]}>
        <Text style={[styles.tableItemText]}>{item.po}</Text>
        <Text style={[styles.tableItemText]}>{item.mo}</Text>
        <Text style={[styles.tableItemText]}>{item.cantidad}</Text>
        <Text style={[styles.tableItemText]}>{item.referencia}</Text>
        <Text style={[styles.tableItemText]}>{item.fechaentrega}</Text>
        <Text style={[styles.tableItemText]}>{item.stamping}</Text>
        <View style={styles.inputWeightContainer}>
          <TextInput
            style={styles.inputWeight}
            value={cantidadInput[item.key] || ""}
            onChangeText={(cantidad) =>
              handleCantidadChange(item.key, cantidad)
            }
            keyboardType='numeric'
            placeholder={cantidadPlaceholder}
            placeholderTextColor={INITIAL_WEIGHING_COLORS.PLACEHOLDER_TEXT}
          />
        </View>

        <View style={styles.inputWeightContainer}>
          <TextInput
            style={styles.inputWeight}
            value={weights[item.key] || ""}
            onChangeText={(weight) => handleWeightChange(item.key, weight)}
            keyboardType='numeric'
            placeholder={calculatedPlaceholder}
            placeholderTextColor={INITIAL_WEIGHING_COLORS.PLACEHOLDER_TEXT}
          />
        </View>

        <TouchableOpacity
          onPress={() => handleAdd(item)}
          style={styles.buttonAddWeight}>
          <Text style={styles.tableItemTextWhite}>
            {translateText("Añadir", lang)}
          </Text>
        </TouchableOpacity>
      </View>
    );
  };

  const renderList = () => {
    if (listData.length == 0) {
      return (
        <Text style={{ fontSize: 16, color: "white", textAlign: "center" }}>
          {translateText("Todos los pesos añadidos", lang)}
        </Text>
      );
    }
    const dataList = [firstLineData, ...listData];

    if (searchResult) {
      return renderItem({ item: searchResult });
    } else {
      return (
        <FlatList
          data={listData}
          keyExtractor={(item) => item.key}
          renderItem={renderItem}
        />
      );
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View
          style={[styles.tableContainerWeight, styles.tableLeft, { flex: 1 }]}>
          <View style={[styles.tableTitleContainer]}>
            <View style={[styles.inputContainer, { flexDirection: "row" }]}>
              <TextInput
                style={styles.inputRef}
                onChangeText={setRefSearch}
                onKeyPress={handleKeyPress}
                value={refSearch}
                placeholder={translateText("Código de MO", lang)}
                placeholderTextColor='rgba(0, 0, 0, 0.4)'
              />
              <TouchableOpacity
                onPress={handleSearch}
                style={styles.searchButton}>
                <MaterialCommunityIcons
                  name='magnify'
                  size={25}
                  color='white'
                />
              </TouchableOpacity>
            </View>
            <Text style={[styles.tableTitle, { width: "100%", marginLeft: 5 }]}>
              {translateText("Tabla de MO", lang)}
            </Text>
          </View>
          {isLoading ? (
            <ActivityIndicator size='large' color={INITIAL_WEIGHING_COLORS.LOADING_INDICATOR} />
          ) : (
            renderList()
          )}
        </View>
      </View>
      <View>
        {" "}
        <DeleteWeightButton
          currentScreenId={currentScreenId}
          onWeightDeleted={handleWeightDeleted}
        />
      </View>

      <AppDialog
        open={confirmVisible}
        onClose={() => {
          setConfirmVisible(false);
          confirmResolverRef.current?.(false);
        }}
        title='Confirmación'
        maxWidth='xs'
        actions={
          <>
            <AppButton
              onClick={() => {
                setConfirmVisible(false);
                confirmResolverRef.current?.(false);
              }}
              variantType='secondary'>
              Cancelar
            </AppButton>
            <AppButton
              onClick={() => {
                setConfirmVisible(false);
                confirmResolverRef.current?.(true);
              }}>
              Aceptar
            </AppButton>
          </>
        }>
        <Text>{confirmMessage}</Text>
      </AppDialog>
    </View>
  );
}
